import React from 'react';
import ToDosView from 'pages/Dashboard/pages/Todos/ToDosView';

export default function ToDos() {
  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden [contain:inline-size]">
      <ToDosView />
    </div>
  );
}
